module.exports = __webpack_public_path__ + "img/barra.1e22dbac.png";